export default __webpack_public_path__ + "static/media/payment-method-visa.ae586fd3.png";